import { FC } from 'react';
import XUIIcon from '@xero/xui/react/icon';
import externalIcon from '@xero/xui-icon/icons/external';
import './index.css';

export interface ILinkProps {
    className?: string;
    displayLinkIcon: boolean;
    href?: string;
    onClick?: () => void;
}

const Link: FC<ILinkProps> = ({ className, displayLinkIcon, href, onClick, children }) => {
    return (
        <a className={className} href={href} target='_blank' onClick={onClick}>
            {children}
            {displayLinkIcon ? <XUIIcon icon={externalIcon} className='link-icon' /> : null}
        </a>
    );
};

export default Link;
